import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EcryptServiceService } from './ecrypt-service.service';

@Injectable({
  providedIn: 'root'
})
export class AttributeService {

  constructor(private http: HttpClient,
    private ecryptServiceService: EcryptServiceService,
    private route: ActivatedRoute,) { }

  url = environment.serverAPI + "/api/catalog/attribute/filter";
  url1 = environment.serverAPI + "/api/catalog/attribute";

  filterByAttribute(categoryId: number, value: any): Observable<Object> {
    return this.http.get(`${this.url}/${categoryId}/${value}`);
  }

  attribute(value: any): Observable<Object> {
   let values= this.route.snapshot.queryParamMap.get('sid');
   
    return this.http.get(`${this.url1}?value=${value}`);
  }


}
